var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "templates" },
    [
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Email Template:")]),
          _vm._v(" "),
          _c("md-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:60",
                expression: "'required|max:60'"
              }
            ],
            attrs: { name: "name" },
            on: {
              input: function($event) {
                _vm.template.name = _vm.sanitizeInput($event)
              }
            },
            model: {
              value: _vm.template.name,
              callback: function($$v) {
                _vm.$set(_vm.template, "name", $$v)
              },
              expression: "template.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("name"),
            expression: "errors.has('name')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("name")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Description:")]),
          _vm._v(" "),
          _c("md-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:100",
                expression: "'required|max:100'"
              }
            ],
            attrs: { name: "description" },
            on: {
              input: function($event) {
                _vm.template.description = _vm.sanitizeInput($event)
              }
            },
            model: {
              value: _vm.template.description,
              callback: function($$v) {
                _vm.$set(_vm.template, "description", $$v)
              },
              expression: "template.description"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("description"),
            expression: "errors.has('description')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("description")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Subject:")]),
          _vm._v(" "),
          _c("md-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:100",
                expression: "'required|max:100'"
              }
            ],
            attrs: { name: "subject" },
            on: {
              input: function($event) {
                _vm.template.subject = _vm.sanitizeInput($event)
              }
            },
            model: {
              value: _vm.template.subject,
              callback: function($$v) {
                _vm.$set(_vm.template, "subject", $$v)
              },
              expression: "template.subject"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("subject"),
            expression: "errors.has('subject')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("subject")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Reference Id:")]),
          _vm._v(" "),
          _c("md-input", {
            attrs: { disabled: "" },
            model: {
              value: _vm.template.ref_id,
              callback: function($$v) {
                _vm.$set(_vm.template, "ref_id", $$v)
              },
              expression: "template.ref_id"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "tempTxtArea md-field-margin" },
        [
          _c("label", [_vm._v("Body HTML:")]),
          _vm._v(" "),
          _c("md-textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: { name: "body html" },
            on: {
              blur: function($event) {
                _vm.template.html = $event.target.value
              }
            },
            model: {
              value: _vm.template.html,
              callback: function($$v) {
                _vm.$set(_vm.template, "html", $$v)
              },
              expression: "template.html"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("body html"),
            expression: "errors.has('body html')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("body html")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "tempTxtArea md-field-margin" },
        [
          _c("label", [_vm._v("Body Text:")]),
          _vm._v(" "),
          _c("md-textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:5000",
                expression: "'required|max:5000'"
              }
            ],
            attrs: { name: "body text" },
            on: {
              blur: function($event) {
                _vm.template.text = _vm.sanitizeInput($event.target.value)
              }
            },
            model: {
              value: _vm.template.text,
              callback: function($$v) {
                _vm.$set(_vm.template, "text", $$v)
              },
              expression: "template.text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("body text"),
            expression: "errors.has('body text')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("body text")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Email Category:")]),
          _vm._v(" "),
          _c(
            "md-select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                name: "Email category",
                placeholder: "Email category",
                id: "category"
              },
              model: {
                value: _vm.template.category,
                callback: function($$v) {
                  _vm.$set(_vm.template, "category", $$v)
                },
                expression: "template.category"
              }
            },
            [
              _c("md-option", { attrs: { value: "None" } }, [
                _vm._v("None (no category)")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Approvals" } }, [
                _vm._v("Approvals")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Escalate" } }, [
                _vm._v("Escalate")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Requests" } }, [
                _vm._v("Requests")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Responses" } }, [
                _vm._v("Responses")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Feedback" } }, [
                _vm._v("Feedback")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Referee" } }, [
                _vm._v("Referee")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Unsubscribe" } }, [
                _vm._v("Unsubscribe")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Members" } }, [
                _vm._v("Members")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "Reports" } }, [
                _vm._v("Reports")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "recruiting" } }, [
                _vm._v("Recruiting")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "profileUpdate" } }, [
                _vm._v("Profile Update")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "noFollowUp" } }, [
                _vm._v("No Follow Up")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("Email category"),
            expression: "errors.has('Email category')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("Email category")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c(
            "md-button",
            {
              staticClass: "md-raised md-round md-accent",
              on: { click: _vm.save }
            },
            [_vm._v(_vm._s(_vm.saveText))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-raised md-round md-accent m-left-20",
              on: {
                click: function($event) {
                  return _vm.deleteTemplate()
                }
              }
            },
            [_vm._v("Delete")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24b7c0ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b7c0ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Template.vue
// module id = null
// module chunks = 